<h6 [ngClass]="{'required-custom': required()}">Selected {{prettyName()}}</h6>
<clr-control-helper *ngIf="helperText()">{{helperText()}}</clr-control-helper>
<a *ngFor="let f of this.value; index as i" class="label label-info clickable noselect" (click)="unselect(f, i)">{{this.optionLabels[f]}}
  <span class="badge">{{i + 1}}</span>
</a>
<h6>Available {{prettyName()}}</h6>
<a *ngFor="let f of unusedOptions; index as i" class="label label-info clickable noselect" (click)="select(f, i)">{{f.label}}
</a>
